import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Portal, svgSprite } from '../../hybrid/wrappers';
import { t } from '../../common/components/T';
import { LangContext } from '../../common/decorators/Language';
import css from './alert.module.scss';
import classNames from 'classnames';
import { generateUniqueId } from '../../common/utils/utils';

const Alert = ({ changeAlertSetter }) => {
    const { translation } = useContext(LangContext) || {};
    const [alertData, setAlertData] = useState(false);
    const canSet = useRef(true);
    const alertRef = useRef(null);

    const icons = {
        success: 'check-circle-fill',
        info: 'question-circle-fill',
        error: 'warning-circle-fill',
        warning: 'warning-triangle-fill'
    };

    useEffect(() => {
        changeAlertSetter((data) => {
            !!data?.cont && setAlertData(data);
        });
        return () => (canSet.current = false);
    }, [changeAlertSetter, setAlertData]);

    useEffect(() => {
        if (!alertData?.view || alertData?.view === 'base') {
            const timer = setTimeout(() => {
                if (canSet.current) setAlertData(false);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [alertData]);

    useEffect(() => {
        if (!alertRef.current) {
            return;
        } else {
            if (alertRef.current.getBoundingClientRect().height < 60) {
                alertRef.current.style.alignItems = 'center';
            } else {
                alertRef.current.style.alignItems = 'flex-start';
            }
        }
    });

    if (!alertData) return null;

    const getDefaultText = (alias) => {
        const text = {
            success_save_data: t('success_save_data', 'Данные успешно сохранены', 'all', translation),
            success_send_data: t('success_send_data', 'Данные успешно отправлены', 'all', translation),
            error_get_data: t('error_get_data', 'Ошибка получения данных', 'all', translation),
            error_delete_data: t('error_delete_data', 'Ошибка удаления данных', 'all', translation),
            error_save_data: t('error_save_data', 'Ошибка сохранения данных', 'all', translation),
            error_permission: t('error_permission', 'Ошибка доступа', 'all', translation)
        };
        if (text[alias]) {
            return text[alias];
        }
    };
    switch (alertData?.view) {
        case 'modal':
            return (
                <Portal>
                    <div className={css.alertModalWrapper}>
                        <div className={classNames(css.cursorPointer, css.alertModalCloseX)} onClick={() => setAlertData(false)}>
                            {svgSprite('cross', {
                                width: '12px',
                                height: '12px',
                                fill: 'var(--greyExtraDarkColor)'
                            })}
                        </div>
                        {alertData.cont?.showIcon ? (
                            <div className={css.alertModalIconBlock}>
                                {svgSprite(icons[!alertData.type ? 'info' : alertData.type], {
                                    className: classNames(css[`alertModalIcon_${alertData.type}`], css.alertModalIcon)
                                })}
                            </div>
                        ) : null}

                        <div className={css.alertModalTitle}>{alertData.cont.modalTitle}</div>

                        <div className={css.alertModalText}>{alertData.cont.modalCont}</div>

                        <div
                            className={classNames(css.buttonPadding, css.cursorPointer, css.buttonGray, css.buttonGrayText)}
                            onClick={() => {
                                setAlertData(false);
                            }}
                        >
                            {t('close', 'Закрыть', 'all', translation)}
                        </div>
                    </div>
                </Portal>
            );
        case 'base':
        default:
            return (
                <>
                    <div ref={alertRef} className={classNames(css.alertWrapper, css[`bg_${alertData.type || 'info'}`])}>
                        <div className={css.alertIconBlock}>
                            {svgSprite(icons[!alertData.type ? 'info' : alertData.type], {
                                className: classNames(css.alertIcon, css[`alertIcon_${alertData.type}`])
                            })}
                        </div>
                        <div className={css.alertTextWrapper} key={generateUniqueId()}>
                            {alertData.title ? <p className={css.alertTitle}>{alertData.title}</p> : null}
                            <p className={css.alertText} key={generateUniqueId()}>
                                {alertData.cont === true ? getDefaultText(alertData.default) || null : alertData.cont}
                            </p>
                        </div>
                        <div className={css.alertProgress}>
                            <div
                                className={classNames(css.alertProgressInner, css[`alertProgressInner_${alertData.type}`])}
                            ></div>
                        </div>
                    </div>
                </>
            );
    }
};

Alert.propTypes = { changeAlertSetter: PropTypes.func };

export default Alert;
